import React, { useEffect, useState, useContext } from "react";
import { useNavigate, Link } from 'react-router-dom';
import Context from '../context/context';
import Lang from '../lang/translations';
const config = require("../_helpers/configServizi");
export default function Terms(props) {
    
	const domain = window.location.hostname;
	const url_logo = config.servizi[domain].logo_su_chiaro;
    const  context = useContext(Context)

    let navigate = useNavigate();

    async function disiscrivi() {
        const inviato = Lang( {"w": "testo_popup","page": "unsubscribe"} );
        
        fetch(process.env.REACT_APP_REMARKETING+"/mailRemove",{ 
			method: 'post', 
            headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
				},
			body: JSON.stringify({"event-data":{"recipient":context.email}})
		})
		.then(response => {
            context.setTooltip({visible:true,title:inviato,text:"",variant:"success",autoClose:true,tipo:"like"})
            setTimeout(()=>{
                navigate('/find');
            },3000)
            
        })
        return
    }

       
    return (<>
			<nav>
                    <div  className="navbar navbar-default navbar-fixed-top" role="navigation">
                        <div className="container">
                                <div className="navbar-header">
                                    <Link className="navbar-brand" to="/"><img src={url_logo} className="img-fluid" /></Link>
                                </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                            </div>
                        </div>
                    </div>
                </nav>
				<nav className="navbar navbar-expand-lg navbar-light fixed-top d-none d-lg-block ">
                    <div className="container navbar-desktop">
                        <Link className="navbar-brand" to="/"><img src={url_logo} className="img-fluid" /></Link>
                        <div className="navbar-collapse" id="navbarSupportedContent">
                    
                        
                        </div>{}
                    </div>
            </nav>

            <div className="all-container bg-light pianiAbbonamentoPage">
                <div className="container filters-no-padding" role="main">
                
                    <div style={{marginTop:"60px"}} className="row">
                            <div className="col-md-7 col-12 col-centered">
                            
                                <div class="container">
                                    <h2><Lang w={"titolo"} page={"unsubscribe"}/></h2>
                                    <p><Lang w={"sottotitolo"} page={"unsubscribe"}/></p>

                                    
                                        <button onClick={()=>{disiscrivi()}} type="submit">Disiscriviti</button>
                                    
                                </div>

                            </div>
                    </div>
                </div>
            </div>
      </>)

}